import { Close } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Switch,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { CustomButton } from "../Common/Button/CustomButton";
import "../Common/Common.scss";
import { LoggedInSkeleton } from "../Common/LoggedInSkeleton";
import { DIALOG_MAX_WIDTHS } from "../Common/Modal/ModalWidth";
import { getAdminTopBarButtons } from "../Common/TopNavBar";
import useFetch from "../Common/useFetch";
import ReactTable, { ColDef } from "../ReactTable/ReactTable";
import TabPanel from "../Recon360/NewBusinessPartner/TabPanel";
import "../Recon360/Recon360.scss";
import { a11yProps } from "../Recon360/ReconSettings/ReconSettings";
import "./Admin.scss";
const filter = createFilterOptions<any>();

export const PreProcessingScriptCategory = {
  Own: "own",
  Partner: "partner",
  Common: "common",
  Miscellaneous: "miscellaneous",
};

const PreprocessingScripts = () => {
  const [value, setValue] = useState<number>(0);
  const storeAllLabels = useRef([]);

  const storeTags = useRef<string[]>([]);

  const [accountLevelData, setAccountLevelData] = useState([]);

  const [scriptLevelData, setScriptLevelData] = useState([]);

  const columnDefinitionAccountLevel = React.useMemo(
    (): ColDef<any>[] => [
      {
        header: "Account Name",
        id: "accountName",
        accessorFn: (row) => row.accountName || "",
        filterFn: "contains",
        size: 300,
      },
      {
        header: "Account ID",
        id: "accountId",
        accessorFn: (row) => row.accountId?.toString() || "",
        filterVariant: "autocomplete",
        size: 70,
      },
      {
        header: "Client Name",
        id: "clientName",
        accessorFn: (row) => row.clientName || "",
        filterFn: "contains",
        size: 200,
      },
      {
        header: "Client Type",
        id: "clientType",
        accessorFn: (row) => row.clientType || "",
        filterVariant: "autocomplete",
        size: 200,
      },
      {
        header: "Labels",
        accessorFn: (row) => row.labels?.join(", ") || "",
        size: 200,
        filterVariant: "multi-select",
        Cell: ({ row }) => (
          <div className="category_ui" style={{ width: "100%" }}>
            <Autocomplete
              limitTags={1}
              value={row.original.labels !== null && row.original.labels?.length > 0 ? row.original.labels : []}
              onChange={(_ev, val) => {
                let value = val as string[];
                if (value !== null && value?.length > 0) {
                  if (value[value.length - 1]?.includes("+Add => ")) {
                    value[value.length - 1] = value[value.length - 1].replace('+Add => "', "");
                    value[value.length - 1] = value[value.length - 1].replace('"', "");
                    const removeEmptyVal = value?.filter((el) => {
                      return el !== "";
                    });
                    value = removeEmptyVal;
                  }
                }
                storeAllLabels.current = [...new Set([...storeAllLabels.current, ...value])];

                updateLabelsForActor(row, value);
              }}
              noOptionsText={"Enter a new label"}
              multiple={true}
              id="tags-outlined"
              options={storeAllLabels?.current}
              getOptionLabel={(option) => option}
              filterSelectedOptions={true}
              filterOptions={(_, params) => {
                const filtered = filter(storeAllLabels?.current === null ? [] : storeAllLabels?.current, params);
                // Suggest the creation of a new value
                if (params.inputValue !== "") {
                  filtered.push(`+Add => "${params.inputValue.trim()}"`);
                }
                return filtered;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // placeholder="Add"
                  sx={{
                    "& input": {
                      px: "12px !important",
                    },
                  }}
                />
              )}
              sx={{
                "&, & div": {
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                },
                "& fieldset": {
                  borderWidth: "0.4px",
                  borderRadius: "12px",
                },
              }}
            />
          </div>
        ),
      },
      {
        header: "Partner Overload",
        sticky: "right",
        id: "partnerOverload",
        accessorFn: (row) => row.is_partner_overload || false,
        size: 100,
        Cell: ({ row }) => {
          // State to manage the switch value locally
          const [enabled, setEnabled] = useState(row.original.is_partner_overload || false);
          // State to control dialog visibility
          const [openPartnerOverloadConfirmModal, setOpenPartnerOverloadConfirmModal] = useState(false);
          // State to store temp value before confirmation
          const [tempValue, setTempValue] = useState(false);

          // Function to handle switch toggle
          const handleToggle = (event) => {
            const newValue = event.target.checked;
            // Store the new value temporarily
            setTempValue(newValue);
            // Open the confirmation dialog
            setOpenPartnerOverloadConfirmModal(true);
          };

          // Function to handle dialog confirm
          const handleDialogConfirm = () => {
            // Update the data in your backend
            updatePartnerOverload(row.original.accountId, tempValue);

            // Update the local state
            setEnabled(tempValue);
            // Close the dialog
            setOpenPartnerOverloadConfirmModal(false);
          };

          // Function to handle dialog cancel
          const handleDialogCancel = () => {
            // Close the dialog without changes
            setOpenPartnerOverloadConfirmModal(false);
          };

          return (
            <>
              <Switch
                checked={enabled}
                onChange={handleToggle}
                inputProps={{ "aria-label": "Partner Overload" }}
                size="small"
              />

              <Dialog open={openPartnerOverloadConfirmModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
                <DialogTitle className="dialog-title">
                  <div className="heading-m">Are you sure?</div>
                  <div className="vertical_center_align">
                    <IconButton onClick={handleDialogCancel}>
                      <Close />
                    </IconButton>
                  </div>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                  <Alert severity="info">
                    {" "}
                    {`This will ${tempValue ? "enable" : "disable"} partner script overloading in account.`}
                  </Alert>
                </DialogContent>
                <DialogActions>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="text"
                    onClick={() => {
                      handleDialogCancel();
                    }}
                  >
                    Cancel
                  </CustomButton>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="contained"
                    onClick={() => {
                      handleDialogConfirm();
                    }}
                  >
                    Confirm
                  </CustomButton>
                </DialogActions>
              </Dialog>
            </>
          );
        },
      },
    ],
    []
  );

  const columnDefinitionScriptLevel = React.useMemo(
    (): ColDef<any>[] => [
      {
        header: "Script Name",
        id: "scriptName",
        accessorFn: (row) => row.scriptName || "",
        filterFn: "contains",
        size: 300,
      },
      {
        header: "Script Labels",
        id: "labels",
        accessorFn: (row) => row.labels?.join(", ") || "",
        size: 200,
        filterVariant: "multi-select",
        Cell: ({ row }) => (
          // Existing Autocomplete component for labels
          <div className="category_ui" style={{ width: "100%" }}>
            <Autocomplete
              limitTags={1}
              value={row.original.labels !== null && row.original.labels?.length > 0 ? row.original.labels : []}
              onChange={(_ev, val) => {
                let value = val as string[];
                if (value !== null && value?.length > 0) {
                  if (value[value.length - 1]?.includes("+Add => ")) {
                    value[value.length - 1] = value[value.length - 1].replace('+Add => "', "");
                    value[value.length - 1] = value[value.length - 1].replace('"', "");
                    const removeEmptyVal = value?.filter((el) => {
                      return el !== "";
                    });
                    value = removeEmptyVal;
                  }
                }
                storeAllLabels.current = [...new Set([...storeAllLabels.current, ...value])];
                updateLabelsForScript(row, value);
              }}
              noOptionsText={"Enter a new label"}
              multiple={true}
              id="script-labels-autocomplete"
              options={storeAllLabels?.current}
              getOptionLabel={(option) => option}
              filterSelectedOptions={true}
              filterOptions={(_, params) => {
                const filtered = filter(storeAllLabels?.current === null ? [] : storeAllLabels?.current, params);
                if (params.inputValue !== "") {
                  filtered.push(`+Add => "${params.inputValue.trim()}"`);
                }
                return filtered;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{
                    "& input": {
                      px: "12px !important",
                    },
                  }}
                />
              )}
              sx={{
                "&, & div": {
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                },
                "& fieldset": {
                  borderWidth: "0.4px",
                  borderRadius: "12px",
                },
              }}
            />
          </div>
        ),
      },
      {
        header: "Script Category",
        id: "scriptCategory",
        accessorFn: (row) => row.scriptCategory || "",
        filterVariant: "autocomplete",
        size: 300,
        Cell: ({ row }) => {
          // Dropdown for Script Category
          const categories = Object.values(PreProcessingScriptCategory);
          const [category, setCategory] = useState(row.original.scriptCategory || "");

          return (
            <Autocomplete
              value={category}
              onChange={(_, newValue) => {
                setCategory(newValue);
                // Update backend with new category
                updateScriptCategory(row.original.scriptId, newValue);
              }}
              options={categories}
              renderInput={(params) => <TextField {...params} variant="outlined" size="small" />}
              size="small"
              sx={{ minWidth: 120 }}
            />
          );
        },
      },
      {
        header: "Script Description",
        id: "scriptDescription",
        accessorFn: (row) => row.scriptDescription || "",
        filterFn: "contains",
        size: 300,
        Cell: ({ row }) => {
          // Text field for Script Description
          const [description, setDescription] = useState(row.original.scriptDescription || "");

          return (
            <TextField
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onBlur={() => {
                // Update backend with new description when field loses focus
                updateScriptDescription(row.original.scriptId, description);
              }}
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Enter description"
            />
          );
        },
      },
      {
        header: "Tags",
        id: "tags",
        accessorFn: (row) => row.tags?.join(", ") || "",
        filterFn: "contains",
        size: 300,
        Cell: ({ row }) => {
          return (
            <div className="category_ui" style={{ width: "100%" }}>
              <Autocomplete
                limitTags={1}
                value={row.original.tags !== null && row.original.tags?.length > 0 ? row.original.tags : []}
                onChange={(_ev, val) => {
                  let value = val as string[];
                  if (value !== null && value?.length > 0) {
                    if (value[value.length - 1]?.includes("+Add => ")) {
                      value[value.length - 1] = value[value.length - 1].replace('+Add => "', "");
                      value[value.length - 1] = value[value.length - 1].replace('"', "");
                      const removeEmptyVal = value?.filter((el) => {
                        return el !== "";
                      });
                      value = removeEmptyVal;
                    }
                  }
                  // Update the global storeTags ref with the new values
                  storeTags.current = [...new Set([...storeTags.current, ...value])];

                  updateScriptTags(row.original.scriptId, value);
                }}
                noOptionsText={"Enter a new tag"}
                multiple={true}
                id="script-tags-autocomplete"
                options={storeTags?.current}
                getOptionLabel={(option) => option}
                filterSelectedOptions={true}
                filterOptions={(_, params) => {
                  const filtered = filter(storeTags?.current === null ? [] : storeTags?.current, params);
                  if (params.inputValue !== "") {
                    filtered.push(`+Add => "${params.inputValue.trim()}"`);
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      "& input": {
                        px: "12px !important",
                      },
                    }}
                  />
                )}
                sx={{
                  "&, & div": {
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  },
                  "& fieldset": {
                    borderWidth: "0.4px",
                    borderRadius: "12px",
                  },
                }}
              />
            </div>
          );
        },
      },
      {
        header: "Live Scripts",
        sticky: "right",
        id: "isActive",
        accessorFn: (row) => row.isActive || false,
        size: 200,
        Cell: ({ row }) => {
          // State to manage the switch value locally
          const [enabled, setEnabled] = useState(row.original.isActive || false);
          // State to control dialog visibility
          const [openLiveScriptsConfirmModal, setOpenLiveScriptsConfirmModal] = useState(false);
          // State to store temp value before confirmation
          const [tempValue, setTempValue] = useState(false);

          // Function to handle switch toggle
          const handleToggle = (event) => {
            const newValue = event.target.checked;
            // Store the new value temporarily
            setTempValue(newValue);
            // Open the confirmation dialog
            setOpenLiveScriptsConfirmModal(true);
          };

          // Function to handle dialog confirm
          const handleDialogConfirm = () => {
            // Update the data in your backend
            updateScriptLiveStatus(row.original.scriptId, tempValue);
            // Update the local state
            setEnabled(tempValue);
            // Close the dialog
            setOpenLiveScriptsConfirmModal(false);
          };

          // Function to handle dialog cancel
          const handleDialogCancel = () => {
            // Close the dialog without changes
            setOpenLiveScriptsConfirmModal(false);
          };

          return (
            <>
              <Switch
                checked={enabled}
                onChange={handleToggle}
                inputProps={{ "aria-label": "Live Script toggle" }}
                size="small"
              />

              <Dialog open={openLiveScriptsConfirmModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
                <DialogTitle className="dialog-title">
                  <div className="heading-m">Are you sure?</div>
                  <div className="vertical_center_align">
                    <IconButton onClick={handleDialogCancel}>
                      <Close />
                    </IconButton>
                  </div>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                  <Alert severity="info">
                    {`This will ${tempValue ? "enable" : "disable"} live script during reconciliation.`}
                  </Alert>
                </DialogContent>
                <DialogActions>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="text"
                    onClick={() => {
                      handleDialogCancel();
                    }}
                  >
                    Cancel
                  </CustomButton>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="contained"
                    onClick={() => {
                      handleDialogConfirm();
                    }}
                  >
                    Confirm
                  </CustomButton>
                </DialogActions>
              </Dialog>
            </>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    listListAccounts();
    listScriptsAdmin();
  }, []);

  const updateScriptCategory = async (scriptId, category) => {
    useFetch(API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.url, "PATCH", {
      failureMessage: API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.failureMessage,
      showSuccessToast: true,
      data: {
        scriptId: scriptId,
        scriptCategory: category,
      },
      thenCallBack: () => {
        listScriptsAdmin();
      },
    });
  };

  const updateScriptDescription = async (scriptId, description) => {
    useFetch(API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.url, "PATCH", {
      failureMessage: API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.failureMessage,
      showSuccessToast: true,
      data: {
        scriptId: scriptId,
        scriptDescription: description,
      },
      thenCallBack: () => {
        listScriptsAdmin();
      },
    });
  };

  const updateScriptTags = async (scriptId, tags) => {
    useFetch(API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.url, "PATCH", {
      failureMessage: API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.failureMessage,
      showSuccessToast: true,
      data: {
        scriptId: scriptId,
        tags: tags,
      },
      thenCallBack: () => {
        listScriptsAdmin();
      },
    });
  };

  const updateScriptLiveStatus = async (scriptId, isLive) => {
    useFetch(API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.url, "PATCH", {
      failureMessage: API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.failureMessage,
      showSuccessToast: true,
      data: {
        scriptId: scriptId,
        isActive: isLive,
      },
      thenCallBack: () => {
        listScriptsAdmin();
      },
    });
  };

  const updateLabelsForScript = async (row, value: string[]) => {
    useFetch(API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.url, "PATCH", {
      failureMessage: API_ENDPOINTS.UPDATE_SETTING_AND_CONFIG.failureMessage,
      showSuccessToast: true,
      data: {
        scriptId: row.original.scriptId,
        labels: value,
      },
      thenCallBack: () => {
        listScriptsAdmin();
      },
    });
  };

  const updateLabelsForActor = async (row, value: string[]) => {
    useFetch(API_ENDPOINTS.UPDATE_ACCOUNT_LABELS.url, "PATCH", {
      failureMessage: API_ENDPOINTS.UPDATE_ACCOUNT_LABELS.failureMessage,
      showSuccessToast: true,
      data: {
        accountId: row.original.accountId,
        labels: value,
      },
      thenCallBack: () => {
        listListAccounts();
      },
    });
  };
  const updatePartnerOverload = async (accountId, isOverloaded) => {
    useFetch(API_ENDPOINTS.SET_DEFAULT_SCRIPT_FOR_ACTOR.url, "PATCH", {
      failureMessage: API_ENDPOINTS.SET_DEFAULT_SCRIPT_FOR_ACTOR.failureMessage,
      showSuccessToast: true,
      data: {
        actorId: accountId,
        isPartnerScriptEnabled: isOverloaded,
      },
      thenCallBack: () => {
        listListAccounts();
      },
    });
  };
  const listScriptsAdmin = async () => {
    useFetch(API_ENDPOINTS.LIST_SCRIPTS_ADMIN.url, "GET", {
      failureMessage: API_ENDPOINTS.LIST_SCRIPTS_ADMIN.failureMessage,
      thenCallBack: (res) => {
        setScriptLevelData(res.data.data.scriptsData || []);

        // Extract unique labels from the script data
        const allLabels = res.data.data.scriptsData.reduce((acc, script) => {
          if (script.labels && Array.isArray(script.labels)) {
            return [...acc, ...script.labels];
          }
          return acc;
        }, []);

        // Extract unique tags from the script data
        const allTags = res.data.data.scriptsData.reduce((acc, script) => {
          if (script.tags) {
            // Handle tags whether they're arrays or comma-separated strings
            const tagArray = Array.isArray(script.tags) ? script.tags : script.tags.split(",").map((tag) => tag.trim());
            return [...acc, ...tagArray];
          }
          return acc;
        }, []);

        // Update refs with unique values
        storeAllLabels.current = [...new Set([...storeAllLabels.current, ...allLabels])];
        storeTags.current = [...new Set([...storeTags.current, ...allTags])];
      },
    });
  };
  const listListAccounts = async () => {
    useFetch(API_ENDPOINTS.LIST_ACCOUNTS.url, "GET", {
      failureMessage: API_ENDPOINTS.LIST_ACCOUNTS.failureMessage,
      thenCallBack: (res) => {
        setAccountLevelData(res.data.data || []);
        // Extract unique labels from the account data
        const allLabels = res.data.data.reduce((acc, account) => {
          if (account.labels && Array.isArray(account.labels)) {
            return [...acc, ...account.labels];
          }
          return acc;
        }, []);

        // Update the storeAllLabels ref with unique labels
        // This preserves existing labels and adds new ones from this API response
        storeAllLabels.current = [...new Set([...storeAllLabels.current, ...allLabels])];
      },
    });
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <LoggedInSkeleton topBarButtons={getAdminTopBarButtons("Preprocessing Scripts")}>
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Account Level" {...a11yProps(0)} sx={{ textTransform: "none" }} />
            <Tab label="Script Level" {...a11yProps(1)} sx={{ textTransform: "none" }} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <ReactTable
            enableRowSelection={false}
            enableFacetedValues={true}
            enableRowVirtualization={false}
            layoutMode="semantic"
            columns={columnDefinitionAccountLevel}
            rows={accountLevelData}
            enableAggregations={true}
            positionToolbarAlertBanner={"top"}
            additionalInitialState={{ showColumnFilters: false }}
            internalActionsOrder={["globalFilterToggle", "filterToggle", "showHideColumns", "fullScreenToggle"]}
          />
        </TabPanel>
        <TabPanel value={value} index={1} key={2}>
          <ReactTable
            enableRowSelection={false}
            enableFacetedValues={true}
            enableRowVirtualization={false}
            layoutMode="semantic"
            columns={columnDefinitionScriptLevel}
            rows={scriptLevelData}
            enableAggregations={true}
            positionToolbarAlertBanner={"top"}
            additionalInitialState={{ showColumnFilters: false }}
            internalActionsOrder={["globalFilterToggle", "filterToggle", "showHideColumns", "fullScreenToggle"]}
          />
        </TabPanel>
      </Box>
    </LoggedInSkeleton>
  );
};

export default PreprocessingScripts;
